import React from 'react';
import { usePageConfig } from '../../contexts/PageConfigContext';
import { PrintersList } from './components/PrintersList';

export const PrintersPage: React.FC = () => {
  const { setPageConfig } = usePageConfig();

  React.useEffect(() => {
    setPageConfig({
      title: 'Impresoras',
      actions: []
    });
  }, [setPageConfig]);

  return (
    <div className="w-full">
      <PrintersList />
    </div>
  );
};
